import { useNavigate } from 'react-router-dom';
import Structure from "../components/Structure";
import LandingProps from "../components/LandingProps";
import styles from "./LandingPage.module.css";
import PrimaryNav from "../components/PrimaryNav";

const LandingPage = () => {
  return (
    <><div>
      <PrimaryNav />
    </div>
    <div className={styles.landingpage}>
        <Structure />
        <LandingProps />
      </div></>
  );
};

export default LandingPage;